import { createSlice } from "@reduxjs/toolkit"

const hotspotPanelStateName = "hotspotPanel"

const initialHotspotPanelState = {
    overlayOptions: {
        fieldOfView: true,
        imageOverlay: false,
    },
    listOpen: false,
    previewModalOpen: false,
    panelOpen: false,
    selected: {} as {
        imageId: string
        hotspotId: string
        flightId: string
    },
    filters: {} as { withHotspots: boolean; showRemoved: boolean },
}

type HotspotPanelState = typeof initialHotspotPanelState

const slice = createSlice({
    name: hotspotPanelStateName,
    initialState: initialHotspotPanelState,
    reducers: {
        toggleImageOverlay: (state) => {
            state.overlayOptions.imageOverlay = !state.overlayOptions.imageOverlay
        },
        toggleFieldOfView: (state) => {
            state.overlayOptions.fieldOfView = !state.overlayOptions.fieldOfView
        },
        toggleList: (state) => {
            state.listOpen = !state.listOpen
        },
        setHotspotPanelState: (
            state: HotspotPanelState,
            action: { payload: Partial<HotspotPanelState["selected"]> }
        ) => {
            const isPreviewOpen =
                (action.payload?.hotspotId || action.payload?.imageId) && !state.panelOpen
            state.selected = {
                ...state.selected,
                ...action.payload,
            }

            state.previewModalOpen = !!isPreviewOpen
        },
        closeHotspotPanel: () => {
            return initialHotspotPanelState
        },
        openHotspotPanel: (state: HotspotPanelState) => {
            state.panelOpen = true
            state.previewModalOpen = false
        },
        toggleWithHotspotsFilter: (state) => {
            state.filters.withHotspots = !state.filters.withHotspots
        },
        toggleShowRemovedFilter: (state) => {
            state.filters.showRemoved = !state.filters.showRemoved
        },
    },
})

export const {
    toggleFieldOfView,
    toggleImageOverlay,
    toggleList,
    setHotspotPanelState,
    closeHotspotPanel,
    openHotspotPanel,
    toggleShowRemovedFilter,
    toggleWithHotspotsFilter,
} = slice.actions
export const HotspotPanelReducer = { [hotspotPanelStateName]: slice.reducer }
